import { useEffect } from 'react';
import { useRef, useState } from 'react';
import { Icon } from '../index';
import PropTypes from 'prop-types';

import { useTranslation } from 'react-i18next';

import './accordion.scss';

const Accordion = (props) => {
	const {
		title,
		clazz,
		clazzButton,
		children,
		onClick,
		type,
		name,
		open,
		noHead,
		onLoad,
		edited,
		resetFunc,
	} = props;

	const [isActive, setIsActive] = useState(open);
	const [height, setHeight] = useState('0px');
	const { t } = useTranslation('translation');
	const contentHeight = useRef(null);

	useEffect(() => {
		setIsActive(open);
	}, [open]);

	const updateHeight = () => {
		if (contentHeight.current) {
			setHeight(
				isActive ? `${contentHeight.current.scrollHeight}px` : '0px',
			);
		}
	};

	useEffect(() => {
		setTimeout(() => updateHeight(), 500);
	}, [isActive, children, onLoad]);

	return (
		<div
			name={name}
			className={`accordion${type ? ` accordion--${type}` : ''}${
				clazz ? ` ${clazz}` : ''
			}`}
		>
			{edited && (
				<button
					onClick={resetFunc}
					className={`accordion__reset`}
					type="button"
				>
					{t('reset')}
				</button>
			)}

			{!noHead && (
				<button
					className={`accordion-button${isActive ? ' _active' : ''} ${
						clazzButton ? ` ${clazzButton}` : ''
					}`}
					onClick={() => {
						setIsActive((prev) => !prev);
					}}
					type="button"
				>
					{title}
					{edited && <span className={'filter__selected'}>!</span>}
					<Icon
						size={'m'}
						clazz={'chevrone'}
						spritePath={'chevrone-down'}
					/>
				</button>
			)}

			<div
				ref={contentHeight}
				className={`accordion__body${isActive ? ' _show' : ''}`}
				style={{ height }}
			>
				{children}
			</div>
		</div>
	);
};

Accordion.propTypes = {
	title: PropTypes.string,
	children: PropTypes.node,
	count: PropTypes.object,
	clazzButton: PropTypes.string,
	clazz: PropTypes.string,
	onClick: PropTypes.func,
	type: PropTypes.string,
	name: PropTypes.string,
	open: PropTypes.bool,
	noHead: PropTypes.bool,
	onLoad: PropTypes.func,
	edited: PropTypes.bool,
	resetFunc: PropTypes.func,
};

export default Accordion;
